<template>
  <div class="card input-bet-card">
    <div
      class="card-actions input-bet-tab grid grid-cols-3 gap-2"
      :class="{
        'grid-cols-3': showAddNumber
      }"
    >
      <!-- <button
        v-if="showAddNumber"
        :class="{'active': currentMenu == MENU_ADD_NUMBER}"
        type="button"
        @click="onSelect(MENU_ADD_NUMBER)"
      >
        <div class="flex items-center justify-center font-bold">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
            class="mr-1 hidden sm:block"
          ><path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 002.25-2.25v-15a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 4.5v15a2.25 2.25 0 002.25 2.25z"
          ></path></svg> เพิ่มเลข
        </div>
      </button> -->
      <button
        :class="{'active': currentMenu == MENU_MANUAL}"
        type="button"
        @click="onSelect(MENU_MANUAL)"
      >
        <div class="flex items-center justify-center font-bold">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
            class="mr-1 hidden sm:block"
          ><path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"
          ></path></svg> กดเลขเอง
        </div>
      </button>
      <button
        :class="{'active': currentMenu == MENU_SELECT}"
        type="button"
        @click="onSelect(MENU_SELECT)"
      >
        <div class="flex items-center justify-center font-bold">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
            class="mr-1 hidden sm:block"
          ><path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 002.25-2.25v-15a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 4.5v15a2.25 2.25 0 002.25 2.25z"
          ></path></svg> เลือกจากแผง
        </div>
      </button>
      <button
        :class="{'active': currentMenu == MENU_WIN}"
        type="button"
        @click="onSelect(MENU_WIN)"
      >
        <div class="flex items-center justify-center font-bold">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
            class="mr-1 hidden sm:block"
          ><path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"
          ></path></svg> เลือกแบบเลขวิน
        </div>
      </button>
    </div>
  </div>
</template>
<script>
const MENU_ADD_NUMBER = 'addnumber'
const MENU_MANUAL = 'manual'
const MENU_SELECT = 'select'
const MENU_WIN = 'win'

export default {
  props : { 
    currentMenu: {
      type: String,
      default: MENU_MANUAL
    },
    showAddNumber: {
      type: Boolean,
      default: false,
    }
  },
  computed : { 
    MENU_ADD_NUMBER: () => MENU_ADD_NUMBER,
    MENU_MANUAL: () => MENU_MANUAL,
    MENU_SELECT: () => MENU_SELECT,
    MENU_WIN: () => MENU_WIN,
  },
  methods : {
    onSelect (menu) { 
      this.$emit('change', menu)
    },
  }
}
</script>

<style scoped>
.card {
  background: radial-gradient(ellipse at center top,  var(--bg-secondary-color-v2), var(--bg-secondary-color-v2), var(--bg-secondary-color-v2));
  border-style: none;
}

.card {
  border-radius: .5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1);
  height: auto;
}

.card .card-actions {
  padding: .75rem;
}

.input-bet-card .input-bet-tab button {
  background: radial-gradient(ellipse at center top, #383838, #171717);
}

.input-bet-card .input-bet-tab button.active {
  /* background: radial-gradient(ellipse at center top, #fbefe7, #ffe6d3, #fbefe7); */
  background: white;
  color: rgb(0 0 0 / 1);
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  background-color: rgba(var(--color-primary));
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

svg {
  height: 1.25rem;
  width: 1.25rem;
}
</style>